import { j as s } from "../../../jsx-runtime-CQ7OqOhn.js";
import { buttonStyles as N } from "./Button.styles.js";
import g from "../Loader/Loader.js";
import z from "../ScreenReaderText/ScreenReaderText.js";
import R from "../../../tailwindConfig/bclTwMerge.js";
const T = ["secondary", "primary-outline", "primary-ghost"], B = ({
  buttonRef: a,
  children: l,
  className: n = "",
  color: t = "primary",
  disabled: c,
  isFullWidth: i,
  isLoading: r,
  loadingText: m = "Loading",
  size: d = "base",
  tabIndex: p = 0,
  // Setting default value to solve Safari and Firefox keyboard navigation issues
  type: b = "button",
  variant: e = "filled",
  ...y
}) => {
  const o = `${t}-${e}`, {
    base: u,
    baseColor: x,
    colors: f,
    fullWidth: j,
    size: S,
    variants: h
  } = N, C = R(
    u,
    i && j,
    x[t],
    f[o],
    S[d],
    h[e],
    n
  );
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      ref: a,
      type: b,
      className: C,
      disabled: c || r,
      tabIndex: p,
      "data-loading": r,
      ...y,
      children: [
        /* @__PURE__ */ s.jsx("span", { className: r ? "text-transparent" : "", children: l }),
        r && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(
            g,
            {
              className: "absolute",
              color: T.includes(o) ? "primary" : "secondary"
            }
          ),
          /* @__PURE__ */ s.jsx(z, { children: m })
        ] })
      ]
    }
  );
};
export {
  B as default
};
